module.exports = __webpack_public_path__ + "img/matrix.952f06a0.svg";